const DEFAULT_NUMBER_OF_RETRIES = 3;
const DEFAULT_RETRY_DELAY = 1000;
const DEFAULT_TIMEOUT = 8000;
const DEFAULT_RETRY_ON = [
  100, 101, 102, 103, 429, 408, 500, 501, 502, 503, 504,
];
const DEFAULT_RETRY_CONFIG = {
  timeout: DEFAULT_TIMEOUT,
  retries: DEFAULT_NUMBER_OF_RETRIES,
  retryDelay: DEFAULT_RETRY_DELAY,
  retryOn: DEFAULT_RETRY_ON,
};

const wait = (delay: number) => {
  return new Promise((resolve) => setTimeout(resolve, delay));
};

const fetchRetry = (
  url: string,
  fetchOptions: RequestInit = {},
  retryOptions = DEFAULT_RETRY_CONFIG
): Promise<Response> => {
  const clonedRetryOptions = { ...retryOptions };
  const controller = new AbortController();

  const timeoutController = () => {
    console.log("Request timed out");
    controller.abort();
  };

  const timeoutId = clonedRetryOptions.timeout
    ? setTimeout(timeoutController, clonedRetryOptions.timeout)
    : 0;
  let shouldRetry = clonedRetryOptions.retries > 0;

  const onError = (err: any) => {
    console.log("Fetch error.");
    console.log(err);
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    if (shouldRetry) {
      clonedRetryOptions.retries--;
      return wait(clonedRetryOptions.retryDelay).then(() =>
        fetchRetry(url, fetchOptions, clonedRetryOptions)
      );
    } else {
      throw err;
    }
  };

  const onRetryOn = (response: Response) => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    if (clonedRetryOptions.retryOn.includes(response.status)) {
      console.log("Will retry on " + response.status);
      if (shouldRetry) {
        clonedRetryOptions.retries--;
        shouldRetry = false;
        return wait(clonedRetryOptions.retryDelay).then(() =>
          fetchRetry(url, fetchOptions, clonedRetryOptions)
        );
      }
    }
    return response;
  };

  if (timeoutId) {
    const optionsWithTimeout = {
      ...fetchOptions,
      signal: controller.signal,
    };
    return fetch(url, optionsWithTimeout).then(onRetryOn).catch(onError);
  } else {
    return fetch(url, fetchOptions).then(onRetryOn).catch(onError);
  }
};

export default fetchRetry;
